export const PCD_DOC_LINK =
  'https://platform9.com/docs/private-cloud-director/private-cloud-director'
export const IMAGE_SERVICE_HELP_LINK = `${PCD_DOC_LINK}/image-library---images#debugging-image-library-service-issues`
export const PERSISTENT_STORAGE_SERVICE_HELP_LINK = `${PCD_DOC_LINK}/block-storage-options---configuration#debugging-block-storage-service-problems`
export const NETWORKING_SERVICE_HELP_LINK = `${PCD_DOC_LINK}/networking-overview#debugging-networking-service-issues`
export const COMPUTE_SERVICE_HELP_LINK = `${PCD_DOC_LINK}/add-hosts-Virtualized-Cluster#debugging-compute-service-problems`

export enum ServiceType {
  Compute = 'compute',
  Image = 'image',
  Storage = 'storage',
  Network = 'network',
}
